import {
  GET_ROTA_STATS,
  GET_ROTA_STATS_FAILURE,
  GET_ROTA_STATS_SUCCESS,
  GET_USER_STATS,
  GET_USER_STATS_FAILURE,
  GET_USER_STATS_SUCCESS,
  SET_DROP_REQUESTS,
  SET_OPEN_SHIFT,
  SET_MY_DROPPED_SHIFTS,
  SET_UPCOMING_SHIFTS,
  SET_PULSE_SURVEY_LIST,
  REMOVE_PULSE_SURVEY,
  SET_FEED_LIST,
  SET_SWAP_REQUESTS,
  SET_SWAP_APPROVALS,
  TOGGLE_VIEW_MODAL,
  // modern dashboard
  GET_HR_STATS,
  GET_HR_STATS_SUCCESS,
  GET_HR_STATS_FAILURE,
  //
  GET_SURVEY_STATS,
  GET_SURVEY_STATS_FAILURE,
  GET_SURVEY_STATS_SUCCESS,
  //
  GET_SHIFT_APPROVALS,
  GET_SHIFT_APPROVALS_SUCCESS,
  GET_SHIFT_APPROVALS_FAILURE,
  //
  GET_STAFF_OPS,
  GET_STAFF_OPS_SUCCESS,
  GET_STAFF_OPS_FAILURE,
  //
  GET_TEAM_ACTIVITY,
  GET_TEAM_ACTIVITY_SUCCESS,
  GET_TEAM_ACTIVITY_FAILURE,
  //
  GET_LEAD_ANALYTICS,
  GET_LEAD_ANALYTICS_SUCCESS,
  GET_LEAD_ANALYTICS_FAILURE,
  //
  GET_TEAM_COMM,
  GET_TEAM_COMM_SUCCESS,
  GET_TEAM_COMM_FAILURE,
  //
  GET_MAINTENANCE_STATS,
  GET_MAINTENANCE_STATS_SUCCESS,
  GET_MAINTENANCE_STATS_FAILURE,
  GET_DISCIPLINARY_STATS,
  GET_DISCIPLINARY_STATS_SUCCESS,
  GET_DISCIPLINARY_STATS_FAILURE,
} from "./constants";

export const getUserStats = (payload) => ({
  type: GET_USER_STATS,
  payload,
});
export const getUserStatsSuccess = (payload) => ({
  type: GET_USER_STATS_SUCCESS,
  payload,
});
export const getUserStatsFailure = (payload) => ({
  type: GET_USER_STATS_FAILURE,
  payload,
});

export const getRotaStats = (payload) => ({
  type: GET_ROTA_STATS,
  payload,
});
export const getRotaStatsSuccess = (payload) => ({
  type: GET_ROTA_STATS_SUCCESS,
  payload,
});
export const getRotaStatsFailure = (payload) => ({
  type: GET_ROTA_STATS_FAILURE,
  payload,
});

export const getSurveyStats = (payload) => ({
  type: GET_SURVEY_STATS,
  payload,
});
export const getSurveyStatsSuccess = (payload) => ({
  type: GET_SURVEY_STATS_SUCCESS,
  payload,
});
export const getSurveyStatsFailure = (payload) => ({
  type: GET_SURVEY_STATS_FAILURE,
  payload,
});

export const setOpenShift = (payload) => ({
  type: SET_OPEN_SHIFT,
  payload,
});

export const setDropRequests = (payload) => ({
  type: SET_DROP_REQUESTS,
  payload,
});

export const setMyDroppedShifts = (payload) => ({
  type: SET_MY_DROPPED_SHIFTS,
  payload,
});

export const setUpcomingShifts = (payload) => ({
  type: SET_UPCOMING_SHIFTS,
  payload,
});

export const setPulseSurveyList = (payload) => ({
  type: SET_PULSE_SURVEY_LIST,
  payload,
});

export const removePulseSurvey = (payload) => ({
  type: REMOVE_PULSE_SURVEY,
  payload,
});

export const setFeedList = (payload) => ({
  type: SET_FEED_LIST,
  payload,
});

export const setSwapRequests = (payload) => ({
  type: SET_SWAP_REQUESTS,
  payload,
});

export const setSwapApprovals = (payload) => ({
  type: SET_SWAP_APPROVALS,
  payload,
});

export const toggleViewModal = (payload) => ({
  type: TOGGLE_VIEW_MODAL,
  payload,
});

export const getHrStats = (payload) => ({
  type: GET_HR_STATS,
  payload,
});
export const getHrStatsSuccess = (payload) => ({
  type: GET_HR_STATS_SUCCESS,
  payload,
});
export const getHrStatsFailure = (payload) => ({
  type: GET_HR_STATS_FAILURE,
  payload,
});

export const getShiftApprovals = (payload) => ({
  type: GET_SHIFT_APPROVALS,
  payload,
});
export const getShiftApprovalsSuccess = (payload) => ({
  type: GET_SHIFT_APPROVALS_SUCCESS,
  payload,
});
export const getShiftApprovalsFailure = (payload) => ({
  type: GET_SHIFT_APPROVALS_FAILURE,
  payload,
});

export const getStaffOps = (payload) => ({
  type: GET_STAFF_OPS,
  payload,
});
export const getStaffOpsSuccess = (payload) => ({
  type: GET_STAFF_OPS_SUCCESS,
  payload,
});
export const getStaffOpsFailure = (payload) => ({
  type: GET_STAFF_OPS_FAILURE,
  payload,
});

export const getTeamActivity = (payload) => ({
  type: GET_TEAM_ACTIVITY,
  payload,
});
export const getTeamActivitySuccess = (payload) => ({
  type: GET_TEAM_ACTIVITY_SUCCESS,
  payload,
});
export const getTeamActivityFailure = (payload) => ({
  type: GET_TEAM_ACTIVITY_FAILURE,
  payload,
});

export const getLeadAnalytics = (payload) => ({
  type: GET_LEAD_ANALYTICS,
  payload,
});
export const getLeadAnalyticsSuccess = (payload) => ({
  type: GET_LEAD_ANALYTICS_SUCCESS,
  payload,
});
export const getLeadAnalyticsFailure = (payload) => ({
  type: GET_LEAD_ANALYTICS_FAILURE,
  payload,
});

export const getTeamComm = (payload) => ({
  type: GET_TEAM_COMM,
  payload,
});
export const getTeamCommSuccess = (payload) => ({
  type: GET_TEAM_COMM_SUCCESS,
  payload,
});
export const getTeamCommFailure = (payload) => ({
  type: GET_TEAM_COMM_FAILURE,
  payload,
});

export const getMaintenanceStats = (payload) => ({
  type: GET_MAINTENANCE_STATS,
  payload,
});
export const getMaintenanceStatsSuccess = (payload) => ({
  type: GET_MAINTENANCE_STATS_SUCCESS,
  payload,
});
export const getMaintenanceStatsFailure = (payload) => ({
  type: GET_MAINTENANCE_STATS_FAILURE,
  payload,
});

export const getDisciplinaryStats = (payload) => ({
  type: GET_DISCIPLINARY_STATS,
  payload,
});
export const getDisciplinaryStatsSuccess = (payload) => ({
  type: GET_DISCIPLINARY_STATS_SUCCESS,
  payload,
});
export const getDisciplinaryStatsFailure = (payload) => ({
  type: GET_DISCIPLINARY_STATS_FAILURE,
  payload,
});
